// extracted by mini-css-extract-plugin
module.exports = {"contentWrap":"AddAffliateDiscount_contentWrap__1Qw32","label":"AddAffliateDiscount_label__2Yb16","input":"AddAffliateDiscount_input__1bmaK"};